import type { LayoutExamplePage, LearningAccelerationReport } from '../shared/desktop-api';
import { layoutTypeNames } from '../shared/layout-type-names';

const FAN_SIZE = 3;

/**
 * PAIGE (docs/engineering/workbench-port.md): up to three of a document type's own pages for its card
 * in job setup, from the `typeExamples` Paige's engine host adds to the setup report
 * (`Paige.Engine/Host/StoreTypeExamples.cs`: confirmed first, only pages the workspace can serve).
 * CapturePoint's deck (`SetupTypeDeck.tsx`) fans one page per learned layout, otherwise its own one
 * example page of the type (`typeExamplePage`); these come between the two, so a type read but not
 * yet taught fans three of its documents rather than one. Empty on the desktop, whose report has none.
 */
export function typeOwnPages(
  type: { id: string; name: string },
  report: LearningAccelerationReport | null | undefined,
): LayoutExamplePage[] {
  const names = layoutTypeNames(type, report);
  const seen = new Set<string>();
  const pages: LayoutExamplePage[] = [];
  for (const entry of report?.typeExamples ?? []) {
    if (!names.has(entry.documentType.trim().toLocaleLowerCase())) continue;
    for (const page of entry.pages) {
      if (pages.length === FAN_SIZE || seen.has(page.documentId)) continue;
      seen.add(page.documentId);
      pages.push(page);
    }
  }
  return pages;
}
